export default async (context) => {
    if(context.main.length > 0) {

        let obj = context.main[context.main.length - 1]

        if(obj.type === 'video' && context.main.length > 0) {
            context.overlay = true
            context.popup.value = true
            context.popup.text = `Нежелательно добавлять несколько видео подряд,
                        получится не очень.`
            context.popup.hint = `Попробуйте добавить текст.`
        } else {
            await context.$store.dispatch('edit/setControl', {
                control: 'main'
            })
            context.$router.push('/add-video')
        }

    } else {

        await context.$store.dispatch('edit/setControl', {
            control: 'main'
        })
        context.$router.push('/add-video')

    }
}